const AnalyticalToolsContentFour = () => {
  return (
    <div className="how__work__resource">
      <div className="container">
        <div className="contact__cards row">
          <div className="col-lg-6 col-md-6 col-12 mb-4">
            <div className="contact__card">
              <div className="card-header">
                <img
                  src={
                    process.env.PUBLIC_URL +
                    "/images/markets/instant_withdrawals.png"
                  }
                  alt="play icon"
                />
                <h4>Real-Time Market Insights</h4>
              </div>
              <p>
                Stay ahead of volatility with continuously updated data streams
                that reflect live price movements, economic shifts, and market
                reactions in real time
              </p>
            </div>
          </div>

          <div className="col-lg-6 col-md-6 col-12 mb-4">
            <div className="contact__card">
              <div className="card-header">
                <img
                  src={
                    process.env.PUBLIC_URL +
                    "/images/markets/instant_withdrawals.png"
                  }
                  alt="play icon"
                />
                <h4>Advanced Technical Indicators</h4>
              </div>
              <p>
                Access hundreds of customizable indicators that reveal patterns,
                breakouts, and potential reversals to optimize your strategy.
              </p>
            </div>
          </div>

          <div className="col-lg-6 col-md-6 col-12 mb-4">
            <div className="contact__card">
              <div className="card-header">
                <img
                  src={
                    process.env.PUBLIC_URL +
                    "/images/markets/instant_withdrawals.png"
                  }
                  alt="play icon"
                />
                <h4>Fundamental Data Access</h4>
              </div>
              <p>
                Track key macroeconomic releases and policy updates that shape
                market sentiment and long-term price trends.
              </p>
            </div>
          </div>

          <div className="col-lg-6 col-md-6 col-12 mb-4">
            <div className="contact__card">
              <div className="card-header">
                <img
                  src={
                    process.env.PUBLIC_URL +
                    "/images/markets/instant_withdrawals.png"
                  }
                  alt="play icon"
                />
                <h4>Intuitive User Experience</h4>
              </div>
              <p>
                All tools are built for clarity and usability, with smooth
                navigation, visual dashboards, and adaptive layouts that make
                complex analysis easy to grasp.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AnalyticalToolsContentFour;
